
import React from "react";
import { useAuth } from "@/contexts/auth";
import SimplifiedRefundHeader from "./components/SimplifiedRefundHeader";
import DemoUsageIndicator from "./components/DemoUsageIndicator";
import QuickTemplates from "./components/QuickTemplates";
import SimplifiedRefundFormFields from "./components/SimplifiedRefundFormFields";
import TrustIndicators from "./components/TrustIndicators";
import SuccessState from "./components/SuccessState";
import { useSimplifiedRefundForm } from "./hooks/useSimplifiedRefundForm";

interface SimplifiedRefundFormProps {
  id?: string;
}

const SimplifiedRefundForm = ({ id }: SimplifiedRefundFormProps) => {
  const { user } = useAuth();
  const {
    formData,
    isSubmitting,
    isSubmitted,
    hasUsedDemo,
    handleFieldChange,
    handleFormatChange,
    handleQuickFill,
    handleSubmit
  } = useSimplifiedRefundForm();

  if (isSubmitted) {
    return <SuccessState isAuthenticated={!!user} />;
  }

  return (
    <section id={id} className="py-8 bg-gradient-to-b from-white/20 to-white/40">
      <div className="container px-4">
        <div className="max-w-lg mx-auto">
          <SimplifiedRefundHeader 
            isAuthenticated={!!user} 
            hasUsedDemo={hasUsedDemo} 
          />

          <DemoUsageIndicator show={!user && hasUsedDemo} />

          <QuickTemplates onTemplateSelect={handleQuickFill} />

          <SimplifiedRefundFormFields
            formData={formData}
            isSubmitting={isSubmitting}
            isAuthenticated={!!user}
            hasUsedDemo={hasUsedDemo}
            onFieldChange={handleFieldChange}
            onFormatChange={handleFormatChange}
            onSubmit={handleSubmit}
          />

          <TrustIndicators 
            isAuthenticated={!!user} 
            hasUsedDemo={hasUsedDemo} 
          />
        </div>
      </div>
    </section>
  );
};

export default SimplifiedRefundForm;
